export const CUSTOM_SITES_CARDS_EXTENSION_FF = 'confluence.frontend.custom-sites.cards-extension';
export const CUSTOM_SITES_CARDS_EXTENSION_VISUAL_CARDS_FF =
	'confluence.frontend.custom-sites.cards-extension-visual-cards';
